import React, { createContext, useContext, useState, useEffect } from 'react';
import { Preloader } from '../Components/Preloader/Preloader';

interface LoaderContextType {
  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;
}

const LoaderContext = createContext<LoaderContextType | undefined>(undefined);

export const LoaderProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isLoading, setIsLoading] = useState<boolean>(() => {
    const stored = localStorage.getItem('isLoading');
    return stored ? JSON.parse(stored) : false;
  });

  useEffect(() => {
    localStorage.setItem('isLoading', JSON.stringify(isLoading));
  }, [isLoading]);

  return (
    <LoaderContext.Provider value={{ isLoading, setIsLoading }}>
      <Preloader isActive={isLoading} />
      {children}
    </LoaderContext.Provider>
  );
};

export const useLoader = () => {
  const context = useContext(LoaderContext);
  if (!context) {
    throw new Error('useLoader must be used within LoaderProvider');
  }
  return context;
};